import React from "react";
import { Link } from "react-router-dom";

function Poupe() {
  return (
    <div>
      <Link to="/poupe/terms">
        <div>Terms and Conditions</div>
      </Link>
      <Link to="/poupe/policy">
        <div>Privacy Policy</div>
      </Link>
    </div>
  );
}

export default Poupe;
